import {
    LOAD_SPACE_CONTENT_ARCHIVED,
    SET_SPACE_CONTENT_ARCHIVED,
    UNSET_SPACE_CONTENT_ARCHIVED,
} from "../services/constants"
import http from "../services/axios"
import Vue from "vue"

export const archiveModule = {
    state: {
        spaceContent: {},
    },
    mutations: {
        [SET_SPACE_CONTENT_ARCHIVED]: (state, payload) => {
            if (!state.spaceContent[payload.identifier]) {
                Vue.set(state.spaceContent, payload.identifier, payload.data)
            } else {
                state.spaceContent[payload.identifier] = payload.data;
            }
        },
        [UNSET_SPACE_CONTENT_ARCHIVED]: (state) => {
            state.spaceContent = {}
        },
    },
    actions: {
        [LOAD_SPACE_CONTENT_ARCHIVED]: (context, payload) => {
            context.commit(SET_SPACE_CONTENT_ARCHIVED, {
                identifier: payload.identifier,
                data: null,
            });

            let url = ''
            let requestPayload = {
                params: {}
            }
            if (payload.identifier === 'all') {
                url = `api/management/spaces/${context.rootState.spaceMetadata.id}/entries`
            } else {
                url = `api/management/spaces/${context.rootState.spaceMetadata.id}/entries/${payload.identifier}`
            }
            if (payload.filterRef) {
                // add on query parameters based on filter state
                if (payload.filterRef.showArchived) {
                    requestPayload.params['showArchived'] = true
                }
            }
            return http.get(url, requestPayload)
                .then(results => {
                    context.commit(SET_SPACE_CONTENT_ARCHIVED, {
                        identifier: payload.identifier,
                        data: results.data,
                    });
                }).catch(err => {
                    console.log(payload)
                    console.log(err)
                })
        },
    }
}